import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { formatarData, parseInstanteOuNulo } from '../../../shared/dominio/datas';
import { ROTULOS_DE_TIPO_DE_FONTE, type TipoDeFonte } from '../api/tipos';

/** "2026-06-01" → "01/06/2026": a vigência vem como data pura, sem fuso a converter. */
function formatarVigencia(iso: string): string {
  const [ano, mes, dia] = iso.split('-');
  return ano !== undefined && mes !== undefined && dia !== undefined ? `${dia}/${mes}/${ano}` : iso;
}

export interface DadosDaFonte {
  readonly tipo: TipoDeFonte;
  readonly criadaEm: string;
  readonly paginas: number | null;
  readonly totalDeItens: number;
  /** Início do hash do arquivo; `undefined` quando a origem do dado não o traz. */
  readonly hash?: string;
  readonly vigenciaIni?: string;
}

/**
 * Uma fonte numa linha só: tipo, quando foi enviada, tamanho e a "impressão digital" do arquivo.
 * Só o nome não identifica um documento — duas fontes do mesmo tipo e mesmo dia se distinguem pelo hash.
 */
export function ReferenciaDaFonte({ fonte }: { fonte: DadosDaFonte }): React.JSX.Element {
  const criada = parseInstanteOuNulo(fonte.criadaEm);

  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
      <Chip size="small" color="primary" variant="outlined" label={ROTULOS_DE_TIPO_DE_FONTE[fonte.tipo]} />
      <Typography variant="body2">
        {[
          criada !== null ? `enviado em ${formatarData(criada)}` : null,
          fonte.vigenciaIni !== undefined ? `vigência desde ${formatarVigencia(fonte.vigenciaIni)}` : null,
          fonte.paginas !== null ? `${String(fonte.paginas)} p.` : null,
          fonte.totalDeItens > 0 ? `${String(fonte.totalDeItens)} itens` : 'só regras, sem itens',
        ]
          .filter((parte): parte is string => parte !== null)
          .join(' · ')}
      </Typography>
      {fonte.hash !== undefined && fonte.hash !== '' ? (
        <Tooltip title="Os 8 primeiros caracteres do hash do arquivo: dois arquivos iguais têm o mesmo código.">
          <Chip size="small" variant="outlined" label={`arquivo ${fonte.hash}`} sx={{ fontFamily: 'monospace' }} />
        </Tooltip>
      ) : null}
    </Stack>
  );
}
